export default __webpack_public_path__ + "static/media/morricana.b47fe734.webp";